import React from 'react';

import { Relevant } from '../ExtendedRelevantField';

export const withRelevantField = (props) => {
  const {
    field,
    relevantCondition,
    checkAdditionalRelevantCondition,
    additionalRelevantCondition,
    values: updatedValues
  } = props;

  return (
    <Relevant
      key={field}
      // NOTE: We deliberately ignore the `values` coming from Informed here
      // and instead evaluate relevance against the `updatedValues` that are
      // computed and passed from the NIAT application layer.
      when={({ values }) => {
        values = {
          ...updatedValues,
          ...values
        };

        if (checkAdditionalRelevantCondition) {
          return eval(relevantCondition) && additionalRelevantCondition;
        }
        return eval(relevantCondition);
      }}
    >
      {props.component}
    </Relevant>
  );
};

export const getWrappedWithRelevantField = (fieldProps) => {
  const {
    field,
    isRelevant,
    relevantCondition,
    component,
    checkAdditionalRelevantCondition,
    additionalRelevantCondition,
    values
  } = fieldProps;

  return isRelevant
    ? withRelevantField({
        field,
        relevantCondition,
        component,
        checkAdditionalRelevantCondition,
        additionalRelevantCondition,
        values
      })
    : component;
};

export const getRelevantLabel = (fieldProps) => {
  // NOTE: values are used to evaluate the condition
  const { relevantLabel, values: labelValues } = fieldProps;
  const values = labelValues;

  return eval(relevantLabel);
};
